import { Type } from './response-lists.component';

export default class InputDefinitionHelper {
  public static mapResponseItemsTypeToInputDefinitionName(columns, responseItems) {
    const inputDefinitionsMap = this.createInputDefinitions(columns);

    responseItems.forEach((item) => {
      for (const [k, v] of Object.entries(item.data)) {
        if (inputDefinitionsMap.has(k)) {
          const mappedObjects = inputDefinitionsMap.get(k) as Array<any>;
          const columnData = v as string;
          if (columnData === null) {
            continue;
          }
          const multiChoices = columnData.split(';');
          if (multiChoices.length > 1) {
            // If size > 1 its a multichoice
            let result = '';

            for (let i = 0; i < multiChoices.length; i++) {
              const found = mappedObjects.find((m) => m.key === multiChoices[i]);
              if (found && found.name) {
                result += this.stripHtml(found.name);
              } else {
                result += multiChoices[i];
              }
              if (i < multiChoices.length - 1) {
                result += ' | ';
              }
            }
            item.data[k] = result;
          } else {
            const found = mappedObjects.find((m) => m.key === v);
            if (found && found.name) {
              item.data[k] = this.stripHtml(found.name);
            } else {
              item.data[k] = v;
            }
          }
        }
      }
    });
  }

  public static mapGraphKeysItemsTypeToInputDefinitionName(columns, column) {
    const inputDefinitionsMap = this.createInputDefinitions(columns);
    const inputDefinition = inputDefinitionsMap.get(column.key) as Array<any>;

    if (inputDefinition) {
      for (const value of column.values) {
        const row = inputDefinition.find((x) => x.key === value.name);
        if (row && row.name.length > 0) {
          value.name = this.stripHtml(row.name);
        }
      }
    }
  }

  private static createInputDefinitions(columns) {
    const excludedTypes = [Type.StarRating];
    const inputDefinitions = columns.filter((x) => x.inputDefinitions != null && !excludedTypes.includes(x.type));
    return new Map(
      inputDefinitions.map((object) => {
        return [object.key, object.inputDefinitions];
      }),
    );
  }

  private static stripHtml(html) {
    const tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }
}
